import React,{useState,useEffect} from 'react'
import moment from 'moment';
import Sidemenu from '../../components/sidemenu';
import Header from '../../components/header';
import Footer from '../../components/footer';

import QuestionDetails from '../../components/questionDetails';
import './custom.css'
import * as Styled from './styled';


import deleteIcon from '../../images/delete.svg';

import { functionService } from '../../lib/functions';

const LinkedinJobs=()=>{

  const [tasks, setTasks] = useState([]);
  const [loading,setLoading]=useState(true)

  const changeStatus=async(id,status)=>{
    try {
      await functionService.get(`easyapply/update-status/${id}?status=${status}`)

    } catch (error) {
      console.log(error)
    }
  }

  const toggleTask = (index,id) => {
    const updatedTasks = [...tasks];
   updatedTasks[index].status = updatedTasks[index].status==="INPROGRESS"?updatedTasks[index].status="PAUSED":updatedTasks[index].status="INPROGRESS";
   changeStatus(id,updatedTasks[index].status)
    setTasks(updatedTasks);

  };

  function formatDate(inputDate) {
    const date = moment(inputDate);
    const formattedDate = date.format('DD-MMM-YY | hh:mm A');
    return formattedDate;
  }

  const deleteJob=async(id)=>{
    try {
      const {response}=await functionService.get(`easyapply/delete/${id}`)

    } catch (error) {
      console.log(error)
    }

  }
  const removeTask = (id) => {
    const updatedTasks = [...tasks];
    const index = updatedTasks.findIndex(obj => obj.id === id);
   deleteJob(id)

    updatedTasks.splice(index, 1);
    setTasks(updatedTasks);
  };

  const getData=async()=>{
    try {

      let {response:{data:{data}}}=await functionService.get('easyapply/get-all')
    setTasks(data)
    setLoading(false)
    } catch (error) {
      console.log(error)
    }

  }


useEffect( ()=>{
 getData()

},[tasks.length])

    return (
        <Styled.MainDiv>

        <QuestionDetails  />
        <Sidemenu  />
        <Styled.ColumnDiv>
          <Header />
{loading===false? <Styled.ContentWrapDiv>
            <Styled.ContentDiv>
              <Styled.HeaderWrapDiv>
                <div>Linkedin Jobs</div>
               { tasks.length>0?<div style={{display: "flex", alignItems: "center", justifyContent: "space-betweeen"}}>
                  <Styled.AddLink to="/easyapply/add"><span>+</span>Add New</Styled.AddLink>

                </div>:null}
              </Styled.HeaderWrapDiv>

              <Styled.CardDiv>
                <Styled.QuestionTable>
                  {tasks.length>0?
                  <>
                <thead >
                <tr>
                  <th>Job Title </th>
                  <th>Job ID</th>
                  <th>Last Run On</th>
                  <th>Applications</th>
                  <th>Status</th>
                  <th>Action</th>
                  </tr>
              </thead>
              <tbody>
              {tasks?.map((item,index)=>(
                <tr>
                  <td >{item?.job_title}</td>
                  <td  >{item?.job_id}</td>
                  <td  >{formatDate(item?.updated_at)}</td>
                  <td  >{item?.total_applied}</td>

                  <td style={{display:'flex',flexDirection:'column'}} >
                 <label className="switch">
              <input
                type="checkbox"
                checked={item?.status==="INPROGRESS"}
                onChange={() => toggleTask(index,item.id)}
              />
              <span className="slider"></span>
            </label>
            <span style={{marginBottom:'-5px',paddingTop:'3px'}}>
              {item.status}
            </span>
            </td>
            <td >
             <button onClick={() => removeTask(item.id)}>
               <img src={deleteIcon} alt="delete" title="Delete Question" />
             </button>
                </td>
              </tr>
              ))
          }

              </tbody>
              </>
                :  <div style={{display: "flex", alignItems: "center", justifyContent: "center",flexDirection:'column',height:'70vh'}}>
                  <p style={{fontSize:'16px',fontWeight:'700'}}>There is no job posted so far.</p>
                <Styled.AddLink to="/easyapply/add">Add New</Styled.AddLink>

              </div>}

                </Styled.QuestionTable>


              </Styled.CardDiv>
            </Styled.ContentDiv>

            <Footer />
          </Styled.ContentWrapDiv>:
          <div style={{display:'flex',justifyContent:'center',alignItems:'center'}}/>

            }


        </Styled.ColumnDiv>
      </Styled.MainDiv>
    )
}
export default LinkedinJobs